import React from 'react';
import AdyenMerchantListComponent from './adyen-merchant-list.component';
export default function AdyenMerchantList() {
    return <AdyenMerchantListComponent />;
}
